module.exports = __webpack_public_path__ + "img/file-copy-alt (1).66c0a138.svg";